
import axios from "axios";
import { getToken } from "./cookies";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 10000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
  

    // if (error.response?.status === 401) {
    //   Cookies.remove("adminToken");
    //   window.location.href = "/login";
    // }
  if (error.response?.status === 401) {
      localStorage.removeItem("adminToken");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);




// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       Cookies.remove("adminToken");
//       localStorage.removeItem("user");

//       if (window.location.pathname !== "/login") {
//         window.location.replace("/login");
//       }
//     }

//     return Promise.reject(error);
//   }
// );

export default axiosInstance;